// extracted by mini-css-extract-plugin
export default {"dateTimeLabel":"DateTimeLabel_dateTimeLabel__uIl32","dateTimeType":"DateTimeLabel_dateTimeType__TbPRL"};